export type OpenPopupOptions = {
  scrollbars?: boolean;
  width?: number;
  height?: number;
  offsetX?: number;
  offsetY?: number;
};
export const openPopupTopRight = (
  url: string,
  title?: string,
  options?: OpenPopupOptions,
  windowOpener: Window = window
) => {
  //NOTE: Default values are same as openPopupTopRight
  const {
    scrollbars = false,
    width = 300,
    height = 400,
    offsetX = 80,
    offsetY = 196, // margin + browser header + citizen header + 16 = 196
  } = options || {};

  const screenLeft = windowOpener.screenLeft || windowOpener.screenX;
  const screenTop = windowOpener.screenTop || windowOpener.screenY;

  const screenWidth =
    windowOpener.innerWidth ||
    windowOpener.document.documentElement.clientWidth ||
    windowOpener.screen.width;

  const left = screenLeft + screenWidth - (width + offsetX);
  const top = screenTop + offsetY;

  const features = `
      scrollbars=${scrollbars ? 'yes' : 'no'},
      width=${width},
      height=${height},
      top=${top},
      left=${left}
      `;

  const newWindow = windowOpener.open(url, title, features);

  newWindow?.focus();

  return newWindow;
};

export const openPopupCenter = (
  url: string,
  title?: string,
  options?: Omit<OpenPopupOptions, 'offsetX' | 'offsetY'>,
  windowOpener: Window = window
) => {
  const { width = 300, height = 400 } = options || {};
  const screenWidth =
    windowOpener.innerWidth ||
    windowOpener.document.documentElement.clientWidth ||
    windowOpener.screen.width;
  const screenHeight =
    windowOpener.innerHeight ||
    windowOpener.document.documentElement.clientHeight ||
    windowOpener.screen.height;
  const offsetX = (screenWidth - width) / 2;
  const offsetY = (screenHeight - height) / 2;

  return openPopupTopRight(url, title, { ...options, offsetX, offsetY }, windowOpener);
};
